import { Box, Typography } from '@mui/material';
import { filterSectionLabelSx, helperTextSx } from '../globalFiltersStyles';

const FilterSection = ({ action, label, helperText, helperPlacement = 'below', children }) => (
  <Box width="100%" display="flex" flexDirection="column" gap={helperText ? (helperPlacement === 'above' ? 0 : 0.5) : 2}>
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} width="100%">
      <Typography sx={filterSectionLabelSx}>{label}</Typography>
      {action ? <Box flexShrink={0}>{action}</Box> : null}
    </Box>
    {helperText && helperPlacement === 'above' ? (
      <Typography sx={{ ...helperTextSx, mt: 0.8, mb: 1.2 }}>{helperText}</Typography>
    ) : null}
    <Box display="flex" flexDirection="column" gap={helperText && helperPlacement === 'below' ? 0.8 : 2}>
      {children}
      {helperText && helperPlacement === 'below' ? <Typography sx={{ ...helperTextSx, px: 2 }}>{helperText}</Typography> : null}
    </Box>
  </Box>
);

export default FilterSection;
